import React, { useState } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";
import Select from "react-select";

import { isAuthorized } from "../../utils/RolesHelpers";
import LazyImage from "../Shared/LazyImage";
import {
    getReactSelectStyling,
    getReactSelectTheme,
} from "../../utils/ReactSelectStyles";
import useClickOutside from "../../utils/CustomHooks/useClickOutside";

const SettingsMenu = ({
    menuOptions,
    headerDropdownOpen,
    setHeaderDropdownOpen,
    selectedOrganization,
    orgToBeChanged,
    setSwitchAccountsModal,
}) => {
    const [roles] = useState([]);
    const { t } = useTranslation();
    //Switch account dropdown states
    const [menuOpen, setMenuOpen] = useState(false);

    const handleLinkClicked = () => {
        setHeaderDropdownOpen(false);
    };

    const renderGroupMenuList = () => {
        return menuOptions?.map((option, index) => {
            return (
                !option.hide && (
                    <span key={index}>
                        <span className="group-menu-item pl-3">
                            {t(option.group)}
                        </span>
                        {renderMenuListItems(option)}
                        {option.horizontalLine && <hr className="mx-2 my-1" />}
                    </span>
                )
            );
        });
    };

    const renderMenuListItems = (option) => {
        if (
            !option?.hide &&
            (!option?.roles || isAuthorized(option?.roles, roles))
        ) {
            return renderItems(option);
        }
    };

    const renderItems = (option) => {
        switch (option.type) {
            case "info":
                return renderInfoItem(option.items);

            case "link":
                return renderLinkItem(option.items);

            case "account":
                return renderAccountItem(option.items, option.defaultValue);
        }
    };

    const renderInfoItem = (option) => {
        return option?.map((item, index) => (
            <li key={index}>
                <div className="flex items-center gap-1">
                    <span className="text-xxs text-main-gray font-medium">
                        {t(item.label)}:
                    </span>
                    <span className="text-xs">{item?.value}</span>
                </div>
            </li>
        ));
    };

    const renderLinkItem = (option) => {
        return option?.map(
            (item, index) =>
                !item.hide && (
                    <Link
                        key={index}
                        to={item?.path}
                        onClick={item.callback || handleLinkClicked}
                    >
                        <li className="click-item">
                            <i className={item?.icon} />
                            {item?.name}
                        </li>
                    </Link>
                )
        );
    };

    const mapAccountItem = (item) => ({
        value: item?.value,
        label: item?.label && (
            <div className="flex items-center gap-1">
                <span className="inline-block w-7 ">
                    <LazyImage
                        src={
                            item?.image ||
                            require("../../assets/images/org-avatar.png")
                                .default
                        }
                        alt="avatar"
                    />
                </span>
                <span className="whitespace-nowrap text-xxs">
                    {item?.label}
                    {item?.default && (
                        <span className=""> ({t("default")})</span>
                    )}
                </span>
            </div>
        ),
        role: item?.role,
        name: item?.label,
    });

    const reformatAccountItems = (items) =>
        items?.map((item) => mapAccountItem(item));

    useClickOutside(() => {
        setMenuOpen(false);
    });
    //Not controllable if user settings menu is not open
    const selectClickHandler = () => {
        headerDropdownOpen && setMenuOpen(!menuOpen);
    };

    const renderAccountItem = (items, defaultValue) => {
        return (
            <li onClick={selectClickHandler}>
                <Select
                    value={selectedOrganization || mapAccountItem(defaultValue)} // Maps the default value if there is no selected item
                    options={reformatAccountItems(items)}
                    placeholder={t("selectPlaceholder", {
                        entity: t("affiliate"),
                    })}
                    theme={getReactSelectTheme}
                    styles={getReactSelectStyling()}
                    onChange={handleSelectChange}
                    menuIsOpen={menuOpen}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                    menuShouldScrollIntoView={false}
                />
            </li>
        );
    };

    const handleSelectChange = (organization) => {
        orgToBeChanged.current = organization;
        setHeaderDropdownOpen(false);
        setSwitchAccountsModal(true);
    };

    return (
        <ul
            className={`dropdown-user-menu ${headerDropdownOpen ? "show" : ""}`}
            id="user-dropdown"
        >
            {renderGroupMenuList()}
        </ul>
    );
};

export default SettingsMenu;
